export default {"src":"/_next/static/media/dog-basic.8d660e9e.svg","height":264,"width":273};